
import { ChangeDetectorRef, Component, OnInit, TemplateRef } from '@angular/core';
import { FlatTreeControl} from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { FileManagerService } from '../services/fileManager.services';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import * as jwt_decode from 'jwt-decode';
import { Subscription } from 'rxjs';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { MovetoFileManagerComponent } from 'src/app/middleware/common/movetoFileManager/movetoFileManager.component';
import {RenameFileManagerComponent} from 'src/app/middleware/common/renameFileManagerItem/renameFileManager.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss']
})
export class LeftMenuComponent implements OnInit {
  
  databaseId:any;
  organizationId:string;
  currentUser: any;
  responseHolder: any;
  FileManagerFolderList:any;
  rememberNodeArray: any=[];
  activeNode:string="";
  activeNodeReport:string="";
  formDialog: FormGroup;  
  parentId:number=0;
  selectedFolderID: number=0;
  FileManagersubFolderFolderList: any;
  hierarchyList: any;
  breadCrumMenu: any=[];
  RefreshListForFileManager: Subscription;
  clickEventsubscriptionFetchleftmenufielmanager:Subscription
  clickEventsubscriptionFromLeftMenu: Subscription;
  selectedRecordDeleteArray: any = [];
  showLocalPanel:boolean = false;
  firstElement:any;

  showForms:boolean = false;
  showReports:boolean = false;
  OfficeIDList: any=[];
  myOfficeID: any;
  SharedWithMeactive:boolean=false;

  showFormsToggle(){
    this.showForms = !this.showForms;
  }

  showReportToggle(){
    this.showReports = !this.showReports;
  }
  
  private _transformer  = (node: FoodNodeFileManager, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      fileManagerItemID:node.fileManagerItemID,
      parentID:node.parentID,
      level: level,
      isShared:node.isShared,
      isFile:node.isFile,
      aiAutomationTemplateID:node.aiAutomationTemplateID,
      aiAutomationTemplateName:node.aiAutomationTemplateName
    };
  }

  private _transformerFileManager = (node: ReportNodeFileManager, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      fileManagerItemID: node.fileManagerItemID,
      subFolderID:node.subFolderID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared,
      isFile:node.isFile,
      aiAutomationTemplateID:node.aiAutomationTemplateID,
      aiAutomationTemplateName:node.aiAutomationTemplateName
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNodeFileManager>(node => node.level, node => node.expandable);
  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  treeControlFileManager = new FlatTreeControl<ExampleFlatNodeFileManager>(node => node.level, node => node.expandable);
  treeFlattenerFileManager = new MatTreeFlattener(this._transformerFileManager, node => node.level, node => node.expandable, node => node.children);
  dataSourceFileManager = new MatTreeFlatDataSource(this.treeControlFileManager, this.treeFlattenerFileManager);


  hasChild = (_: number, node: ExampleFlatNodeFileManager) => node.expandable;

  constructor(private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private toastr: ToastrService,private fileManagerService: FileManagerService,
    private router: Router, private statusConstant: StatusConstant,private dialog: MatDialog,
    private _dataSharingService: DataSharingService,private cdr: ChangeDetectorRef, 
    private loaderService: LoaderService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)	
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
       });
     }
 
     ngOnDestroy() {
      this.RefreshListForFileManager.unsubscribe();
      this.clickEventsubscriptionFromLeftMenu.unsubscribe();          
    }

  ngOnInit(): void {

    if(environment.production) {      
      this.showLocalPanel=false;
    }else{     
     this.showLocalPanel=true;
    }
    this.clickEventsubscriptionFetchleftmenufielmanager = this._dataSharingService.getFetchleftmenufielmanager().subscribe((result) => {
      
      if (result) {  
        this.SharedWithMeactive=true;
        this.Formsactive=false;
      }
        });
    this.RefreshListForFileManager = this._dataSharingService.getRefreshListForFileManager().subscribe((result) => {
      this.getFileManagerFolderList();     
      //this.getAllFolder();
    });
    this.clickEventsubscriptionFromLeftMenu = this._dataSharingService.GetSelectedFolderIDFromLeftMenuToDashBoardFileManager().subscribe((result) => {
      if (result != "" && result != undefined) {       
        this.selectedFolderID=result;
      }
    });

    var status= sessionStorage.getItem('FileManagerMenuActive');
    if(status=="true"){
      this.Formsactive=true;
      this.SharedWithMeactive=false;
      sessionStorage.setItem('FileManagerMenuSharedActive','false');
    }else{
      this.Formsactive=false;
      this.SharedWithMeactive=false;
    }
    var status= sessionStorage.getItem('FileManagerMenuSharedActive');
    if(status=="true"){
      this.SharedWithMeactive=true;
      this.Formsactive=false;
    }else{
      this.SharedWithMeactive=false;
    }

   // this.getFileManagerFolderList();
    let groupaddtouchtype = {};
    this.formDialog = new FormGroup(groupaddtouchtype);
    this.formDialog.addControl('filemanagerFolderName', this.formBuilder.control(''));   
  }

  getFileManagerFolderList() { 
    let reqModel = {
      folderID: 0,
      folderName: "", 
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.fileManagerService.getFoldersListForFML(reqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
          this.FileManagerFolderList = this.responseHolder.data.data;
          if(this.FileManagerFolderList!=null){
            this.FileManagerFolderList = this.FileManagerFolderList.filter(function (el) {
              return el != null;
            });
          }
         
          if(this.FileManagerFolderList!=null){
            this.dataSource.data = this.FileManagerFolderList;
            this.firstElement = this.dataSource.data[0];
            if(this.rememberNodeArray.length>0){
              this.rememberNodeArray.forEach(e => {
                document.getElementById(e).click();
              }); 
            }           
          }
        }
        else {
        }
      }
      else {
      }
    });  
  }

  rememberNode(nodeId:any,e) {
    if(!this.rememberNodeArray.find(m=>m==nodeId))
       this.rememberNodeArray.push(nodeId);
       if(e.currentTarget.innerText=='arrow_drop_down'){
        this.rememberNodeArray= this.rememberNodeArray.filter(m=>m!=nodeId)
       }
  }

  showInbox() {
    sessionStorage.setItem('FileManagerMenuActive','false');
    sessionStorage.setItem('FileManagerMenuSharedActive','false');
    sessionStorage.setItem('isSharedWithMeFileManager','false'); 
    this.SharedWithMeactive=false;
    this.Formsactive=false;
    this.activeNode="";
  }

  getLeftMenuList(){
    sessionStorage.setItem('FileManagerMenuActive','true');
    sessionStorage.setItem('isSharedWithMeFileManager','false'); 
    this.SharedWithMeactive=false;
    this.Formsactive=true;
    this.activeNode="";
    this.getFileManagerFolderList();
    this._dataSharingService.sendRefreshListForFileManagerAddFolder(0);
    this._dataSharingService.SendFolderDetailsEmpty("");
    this._dataSharingService.sendSelectedFolderContentFromLeftMenuFileManager("");
    this._dataSharingService.sendSelectedDocForGoogleDrive(null);
  }

  getFileManagerFoldersdetails(fileManager){
    sessionStorage.setItem('FileManagerMenuActive','true');
    sessionStorage.setItem('FileManagerMenuSharedActive','false'); 
    sessionStorage.setItem('isSharedWithMeFileManager','false'); 
    this.SharedWithMeactive=false;
    this.Formsactive=true;
    this.reportsactive=false;
    this.activeNodeReport="";
    this.activeNode=fileManager.fileManagerItemID;
    this.selectedFolderID=Number(fileManager.fileManagerItemID);
    this.router.navigate(['/filemanager']);
    var ReqModel ={      
      fileManagerItemID:fileManager.fileManagerItemID,
      name:"",
      pageSize: 10,
      pageIndex: 1,
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList
    }
    this.fileManagerService.FileManagerItemsWithHierarchy(ReqModel).subscribe(res => {
      if (res != undefined) {
        this.responseHolder = res;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
            this.FileManagersubFolderFolderList = this.responseHolder.data;
            this.hierarchyList = this.responseHolder.data.hierarchy;
            if( this.hierarchyList == null || this.hierarchyList == null){
              this.breadCrumMenu=[];
              var folderDetails ={                 
                breadCrumMenu:this.breadCrumMenu,
                FileManagersubFolderFolderList:this.FileManagersubFolderFolderList.children,
                count :this.FileManagersubFolderFolderList.count,
                pageIndex:this.FileManagersubFolderFolderList.pageIndex,
                pageSize:this.FileManagersubFolderFolderList.pageSize,
                fileManagerItemID:fileManager.fileManagerItemID,
                }
               sessionStorage.setItem('isShared',  fileManager.isShared);
               this._dataSharingService.sendSelectedFolderContentFromLeftMenuFileManager(folderDetails);
               this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(this.responseHolder.data.folderDetail);
            }
            else{
               this.breadCrumMenu=[];
               this.hierarchyList.forEach(e => {
               this.breadCrumMenu.push({ label: e.name,id:e.fileManagerItemID,icon: 'navigate_next' });
                });
               var folderDetails ={                 
                   breadCrumMenu:this.breadCrumMenu,
                   FileManagersubFolderFolderList:this.FileManagersubFolderFolderList.children,
                   count :this.FileManagersubFolderFolderList.count,
                   pageIndex:this.FileManagersubFolderFolderList.pageIndex,
                   pageSize:this.FileManagersubFolderFolderList.pageSize,
                   fileManagerItemID:fileManager.fileManagerItemID,
                   }
                   sessionStorage.setItem('isShared',  fileManager.isShared);
                  this._dataSharingService.sendSelectedFolderContentFromLeftMenuFileManager(folderDetails);
                  this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(this.responseHolder.data.folderDetail);
            }
            
             } else {
                }
            } else {    
          }
    });
  

  }

  FileManagerFolderId:number=0;

  getFileManagerFoldersdetailsReport(fileManager){
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
      var Module =[];
      Module= menuModulesList.filter(x => x.mainModuleName == 'File Manager');
      if(Module.length>0){
        this.FileManagerFolderId= Module[0].folderID;
       }  
    sessionStorage.setItem('FileManagerMenuActive','true');
    sessionStorage.setItem('FileManagerMenuSharedActive','false'); 
    sessionStorage.setItem('isSharedWithMeFileManager','false'); 
    this.SharedWithMeactive=false;
    this.Formsactive=false;
    this.reportsactive=true
    this.activeNodeReport=fileManager.subFolderID;
    this.activeNode="";
   // this.selectedFolderID=Number(fileManager.fileManagerItemID);
    this.router.navigate(['/filemanager']);
    var ReqModel ={      
      fileManagerItemID:0,
      documentTypeID:fileManager.subFolderID,
      name:"",
      pageSize: 10,
      pageIndex: 0,
      searchKey: "",
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList,
      moduleFolderID:this.FileManagerFolderId
    }
    this.fileManagerService.getDocumentsbyType(ReqModel).subscribe(res => {
      if (res != undefined) {
        this.responseHolder = res;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
            this.FileManagersubFolderFolderList = this.responseHolder.data;
            this.hierarchyList = this.responseHolder.data.hierarchy;
            if( this.hierarchyList == null || this.hierarchyList == null){
              this.breadCrumMenu=[];
              var folderDetails ={                 
                breadCrumMenu:this.breadCrumMenu,
                FileManagersubFolderFolderList:this.FileManagersubFolderFolderList.fileManagerItems,
                documentTypeFields: this.responseHolder.data.documentTypeFields,
                subFolderID:fileManager.subFolderID,
                gridSetting: this.responseHolder.data.gridSetting,
                count :this.FileManagersubFolderFolderList.count,
                pageIndex:this.FileManagersubFolderFolderList.pageIndex,
                pageSize:this.FileManagersubFolderFolderList.pageSize,
                fileManagerItemID:fileManager.fileManagerItemID,
                }
               sessionStorage.setItem('isShared',  fileManager.isShared);
               this._dataSharingService.sendSelectedFolderContentFromLeftMenuFileManager(folderDetails);
               this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(this.responseHolder.data.folderDetail);
            }
            else{
               this.breadCrumMenu=[];
               this.hierarchyList.forEach(e => {
               this.breadCrumMenu.push({ label: e.name,id:e.fileManagerItemID,icon: 'navigate_next' });
                });
               var folderDetails ={                 
                   breadCrumMenu:this.breadCrumMenu,
                   FileManagersubFolderFolderList:this.FileManagersubFolderFolderList.children,
                   documentTypeFields: this.responseHolder.data.documentTypeFields,
                   subFolderID:fileManager.subFolderID,
                   gridSetting: this.responseHolder.data.gridSetting,
                   count :this.FileManagersubFolderFolderList.count,
                   pageIndex:this.FileManagersubFolderFolderList.pageIndex,
                   pageSize:this.FileManagersubFolderFolderList.pageSize,
                   fileManagerItemID:fileManager.fileManagerItemID,
                   }
                   sessionStorage.setItem('isShared',  fileManager.isShared);
                  this._dataSharingService.sendSelectedFolderContentFromLeftMenuFileManager(folderDetails);
                  this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(this.responseHolder.data.folderDetail);
            }
            
             } else {
                }
            } else {    
          }
    });
  

  }

  getFileManagerFoldersdetailsLeft(fileManager){
    sessionStorage.setItem('FileManagerMenuActive','true');
    sessionStorage.setItem('FileManagerMenuSharedActive','false'); 
    sessionStorage.setItem('isSharedWithMeFileManager','false'); 
    this.SharedWithMeactive=false;
    this.Formsactive=true;
    this.activeNode=fileManager.fileManagerItemID;
    this.selectedFolderID=Number(fileManager.fileManagerItemID);    
    var ReqModel ={      
      fileManagerItemID:fileManager.fileManagerItemID,
      name:"",
      pageSize: 10,
      pageIndex: 1,
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList
    }
    this.fileManagerService.FileManagerItemsWithHierarchy(ReqModel).subscribe(res => {
      if (res != undefined) {
        this.responseHolder = res;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
            this.FileManagersubFolderFolderList = this.responseHolder.data;
            this.hierarchyList = this.responseHolder.data.hierarchy;
            if( this.hierarchyList == null || this.hierarchyList == undefined){
              this.breadCrumMenu=[];
              var folderDetails ={                 
                breadCrumMenu:this.breadCrumMenu,
                FileManagersubFolderFolderList:this.FileManagersubFolderFolderList.children,
                count :this.FileManagersubFolderFolderList.count,
                pageIndex:this.FileManagersubFolderFolderList.pageIndex,
                pageSize:this.FileManagersubFolderFolderList.pageSize,
                fileManagerItemID:fileManager.fileManagerItemID,
                }
               sessionStorage.setItem('isShared',  fileManager.isShared);
               this._dataSharingService.sendSelectedFolderContentFromLeftMenuFileManager(folderDetails);
               this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(this.responseHolder.data.folderDetail);
            }
            else{
               this.breadCrumMenu=[];
               this.hierarchyList.forEach(e => {
               this.breadCrumMenu.push({ label: e.name,id:e.fileManagerItemID,icon: 'navigate_next' });
                });
               var folderDetails ={                 
                   breadCrumMenu:this.breadCrumMenu,
                   FileManagersubFolderFolderList:this.FileManagersubFolderFolderList.children,
                   count :this.FileManagersubFolderFolderList.count,
                   pageIndex:this.FileManagersubFolderFolderList.pageIndex,
                   pageSize:this.FileManagersubFolderFolderList.pageSize,
                   fileManagerItemID:fileManager.fileManagerItemID,
                   }
                  sessionStorage.setItem('isShared',  fileManager.isShared);
                  this._dataSharingService.sendSelectedFolderContentFromLeftMenuFileManager(folderDetails);
                  this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(this.responseHolder.data.folderDetail);
            }
             } else {
                }
            } else {    
          }
    });
  

  }
  
  openCreateNewFolder(templateRef: TemplateRef<any>){
    this.parentId=0;
    this.dialog.open(templateRef);
    this.formDialog.reset();
  }
  
  openCreateFolderDialogue(templateRef: TemplateRef<any>,node) {
    this.parentId=node.fileManagerItemID;
    this.dialog.open(templateRef);
    this.formDialog.reset();
  }
  
  AddFolderName(data){
    this.dialog.closeAll();
    let request = {
      fileManagerItemID: 0,
      name:  data.filemanagerFolderName.trim(),
      parentID:this.parentId,
      isFile:false,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID:this.myOfficeID      
   }    
   this.fileManagerService.addFolderinFileManager(request).subscribe(response => {
     if (response != undefined) {
       var responseHolder = response;
       if (responseHolder.data ==true && responseHolder.status == this.statusConstant.statusSuccess) {
         this.getFileManagerFolderList();
         this.getFileManagerFoldersdetailsLeft({fileManagerItemID:this.parentId}); 
         this.parentId=0;
         this.formDialog.reset();        
         this.toastr.success('Folder Created successfully.', '', {
           timeOut: 3000,
         });     
       }
       if (responseHolder.data == false && responseHolder.status == 500) {
        this.toastr.warning('Folder Name Already Exist.', '', {
          timeOut: 3000,
        });
       }        
     }
   });
  }


  DeleteFolders(form) {
    var message = `Are you sure you want to delete?`;  
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {   
        let request = {
          id: form.fileManagerItemID,  // FolderID  |  FormID
          itemType: 1//form.type   //{ 1- Folder, 2- Form}        
        };

       this.selectedRecordDeleteArray.push(request);

        var ReqModel = {
          items: this.selectedRecordDeleteArray,
          actionType: -1, //(-1 For Remove),(1 For Favorite)
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
      }      
       this.fileManagerService.DeleteFileManagerItems(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.data == 1) {
              this.toastr.success('Folder Deleted successfully.', '', {
                timeOut: 1000,
              });
               this.getFileManagerFolderList(); 
               this.getFileManagerFoldersdetailsLeft({fileManagerItemID:form.parentID});            
               this.selectedRecordDeleteArray=[];
            }
          }
        });
      }
    });
  }  
  
  close(){
    this.dialog.closeAll();
  }


  MoveTo(folder) {
    var parentId=0;
    parentId= folder.fileManagerItemID;
    // if(folder.isFile==false){
    //   parentId= folder.fileManagerItemID;
    // }else{
    //   parentId = folder.parentID;
    // }
    const dialogRef = this.dialog.open(MovetoFileManagerComponent, {
      data: {       
        fileManagerItemID: folder.fileManagerItemID,
        parentId:parentId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
        this._dataSharingService.getSelectedParentFolderIDForMoveFileManagerItem().subscribe(response=>{
        if(result!=undefined && result!=null){
        this.getFileManagerFolderList(); 
        this.getFileManagerFoldersdetailsLeft({fileManagerItemID:response?.fileManagerItemID});            
        this.selectedRecordDeleteArray=[];
        this._dataSharingService.sendRefreshListForFileManager(true);
        this.selectedRecordDeleteArray = [];
          }
      });
    });
  }

  renameFileManagerItem(fileManagerItemDetails){
    const dialogRef = this.dialog.open(RenameFileManagerComponent, {
      data: {       
        fileManagerItemID: fileManagerItemDetails
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=undefined && result!=null){
        fileManagerItemDetails.name=result;
        this.getFileManagerFoldersdetailsLeft({fileManagerItemID:fileManagerItemDetails.parentID});      
        this.selectedRecordDeleteArray = [];
      }      
    });
  }
  
  Formsactive:boolean = true;
  reportsactive:boolean = false;
  getAllSubfolderListResponseHolder:any=[]=[];
  fileManagerFolderReportList:any=[]=[];

  getSharedWithMe() {
    this.SharedWithMeactive=true;
    this.Formsactive=false;
    this.activeNode="";
    sessionStorage.setItem('FileManagerMenuActive','false');
    sessionStorage.setItem('FileManagerMenuSharedActive','true');
    sessionStorage.setItem('isSharedWithMeFileManager','false'); 
    sessionStorage.setItem('isShared','false');   
    this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(null);
    this._dataSharingService.sendSelectedFolderContentFromLeftMenuFileManager("sharewithmeLeftmenu");
  }

  getAllFolder() {
    var obj={
      userID : this.currentUser.UID,
      databaseID : parseInt(sessionStorage.getItem('databaseId')),
      folderID :0,
      officeID : this.myOfficeID,
      OfficeIDList : this.OfficeIDList,
      organizationID : Number(sessionStorage.getItem('organizationID'))
    }    
    this.fileManagerService.getAllFolderlist(obj).subscribe((response) => {
        if (response != undefined) {
          this.getAllSubfolderListResponseHolder = response;
          if(this.getAllSubfolderListResponseHolder.status == this.statusConstant.statusSuccess) {
            this.getAllSubfolderListResponseHolder.data.forEach((element) => {
              if (element.folderName == 'File Manager') {
                this.fileManagerFolderReportList = element.subFolders;
                if(this.fileManagerFolderReportList.length>0){
                  this.fileManagerFolderReportList.forEach(e => {
                    e.name = e.folderName
                  });
                }
                if(this.fileManagerFolderReportList!=null){
                  this.dataSourceFileManager.data = this.fileManagerFolderReportList;
                  //this.firstElement = this.dataSource.data[0];
                  // if(this.rememberNodeArray.length>0){
                  //   this.rememberNodeArray.forEach(e => {
                  //     document.getElementById(e).click();
                  //   }); 
                  // }           
                }
              } 
            });
          } else {           
          }
        }
      });
  }


}

interface FoodNodeFileManager {
  name: string;
  children?: FoodNodeFileManager[];
  fileManagerItemID:number;
  subFolderID:number;
  parentID:number;
  isShared:boolean;
  isFile:boolean;
  aiAutomationTemplateID:number;
  aiAutomationTemplateName:string;
}

interface ReportNodeFileManager {
  name: string;
  children?: FoodNodeFileManager[];
  fileManagerItemID:number;
  subFolderID:number;
  parentID:number;
  isShared:boolean;
  isFile:boolean;
  aiAutomationTemplateID:number;
  aiAutomationTemplateName:string;
}

interface ExampleFlatNodeFileManager {
  expandable: boolean;
  name: string;
  level: number;
  fileManagerItemID:number;
  subFolderID:number;
  parentID:number;
  isShared:boolean;
  isFile:boolean;
  aiAutomationTemplateID:number;
  aiAutomationTemplateName:string;
}

